import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "space-y-6"
}
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_3 = { class: "space-y-4" }
const _hoisted_4 = { class: "px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-xl bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white min-h-[2.75rem] flex items-center" }
const _hoisted_5 = { class: "px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-xl bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white min-h-[80px] flex items-center" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "space-y-4" }
const _hoisted_8 = { class: "px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-xl bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white min-h-[2.75rem] flex items-center justify-between" }
const _hoisted_9 = { class: "flex items-center min-w-0 flex-1 mr-3" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "flex items-center space-x-2 flex-shrink-0" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 1,
  class: "animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"
}
const _hoisted_14 = {
  key: 1,
  class: "flex items-center text-amber-600 dark:text-amber-400",
  title: "Download restricted to administrators"
}
const _hoisted_15 = {
  key: 0,
  class: "mt-2 text-sm text-amber-600 dark:text-amber-400 flex items-center"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-xl bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white min-h-[2.75rem] flex items-center" }
const _hoisted_18 = { class: "flex items-center text-sm" }
const _hoisted_19 = {
  key: 0,
  class: "border-t pt-6"
}
const _hoisted_20 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_21 = { class: "bg-blue-50 dark:bg-blue-900/30 rounded-lg p-4" }
const _hoisted_22 = { class: "grid grid-cols-2 gap-4 text-sm" }
const _hoisted_23 = ["title"]
const _hoisted_24 = { class: "ml-2 text-gray-600 dark:text-gray-400" }
const _hoisted_25 = { class: "ml-2 text-gray-600 dark:text-gray-400" }
const _hoisted_26 = { class: "ml-2 text-gray-600 dark:text-gray-400" }
const _hoisted_27 = { class: "bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg overflow-hidden" }
const _hoisted_28 = {
  key: 0,
  class: "w-full"
}
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 1,
  class: "p-6 text-center"
}
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 1,
  class: "animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"
}
const _hoisted_33 = {
  key: 1,
  class: "text-amber-600 dark:text-amber-400 text-sm"
}
const _hoisted_34 = {
  key: 2,
  class: "p-4"
}
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = {
  key: 3,
  class: "p-6"
}
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 1,
  class: "animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"
}
const _hoisted_39 = {
  key: 1,
  class: "text-amber-600 dark:text-amber-400 text-sm"
}
const _hoisted_40 = {
  key: 4,
  class: "p-6 text-center"
}
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 1,
  class: "animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"
}
const _hoisted_43 = {
  key: 1,
  class: "text-amber-600 dark:text-amber-400 text-sm"
}
const _hoisted_44 = {
  key: 1,
  class: "bg-gray-50 dark:bg-gray-700 rounded-xl p-8 text-center"
}
const _hoisted_45 = ["disabled"]
const _hoisted_46 = {
  key: 1,
  class: "animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500 mr-2"
}
const _hoisted_47 = {
  key: 1,
  class: "text-center py-8"
}
const _hoisted_48 = {
  key: 0,
  class: "flex items-center text-amber-600 dark:text-amber-400 text-sm mr-auto"
}

import { ref, computed, watch, onMounted, onUnmounted } from 'vue'
import { useToastService } from '@/services/toast'
import { useAuthStore } from '@/stores/auth'
import { getErrorMessage } from '@/utils/errorHandler'
import ModulesService from '@/services/modules'
import BaseModal from '@/components/common/BaseModal.vue'
import BaseButton from '@/components/common/BaseButton.vue'
import { 
  BookOpen, 
  FileText, 
  Download, 
  Calendar,
  Eye,
  ShieldAlert
} from 'lucide-vue-next'
import type { Module } from '@/services/modules'

interface Props {
  isVisible: boolean
  module: Module | null
}

interface Emits {
  (e: 'close'): void
}

interface FilePreviewData {
  module_id: number
  module_name: string
  filename: string
  file_extension: string
  file_size: number
  file_size_formatted: string
  mime_type: string
  file_url: string
  is_previewable: boolean
  preview_type: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewModule',
  props: {
    isVisible: { type: Boolean },
    module: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const toast = useToastService()
const authStore = useAuthStore()

// Reactive state
const isLoadingPreview = ref(false)
const isDownloading = ref(false)
const filePreview = ref<FilePreviewData | null>(null)
const showPreview = ref(false)
const downloadId = ref<string | null>(null)
const windowWidth = ref(window.innerWidth)

// Computed properties
const isAdmin = computed(() => authStore.isAdmin)

// Computed truncation limit based on screen size
const truncationLimit = computed(() => {
  return windowWidth.value < 760 ? 25 : 50
})

// Helper to truncate filename
const truncateFilename = (filename: string): string => {
  const limit = truncationLimit.value
  if (filename.length > limit) {
    return filename.substring(0, limit - 3) + '...'
  }
  return filename
}

// Watch for module changes to reset preview state
watch(() => props.module, (newModule, oldModule) => {
  // Reset preview state when module changes
  filePreview.value = null
  showPreview.value = false
  
  // Also reset if the module ID changed or material_filepath changed
  if (newModule && oldModule && 
      (newModule.module_id !== oldModule.module_id || 
       newModule.material_filepath !== oldModule.material_filepath)) {
    filePreview.value = null
    showPreview.value = false
  }
}, { immediate: true })

// Helper functions
const getFileName = (filePath: string | null | undefined): string => {
  if (!filePath) return 'No file attached'
  const pathParts = filePath.split('/')
  return pathParts[pathParts.length - 1] || 'Unknown file'
}

const getStatusText = (status: string | number | null | undefined): string => {
  if (status === null || status === undefined) return 'Inactive'
  const statusNum = Number(status)
  return statusNum === 1 ? 'Active' : 'Inactive'
}

const getStatusClasses = (status: string | number | null | undefined): string => {
  const statusNum = Number(status)
  return statusNum === 1 
    ? 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300'
    : 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300'
}

const getStatusDotClass = (status: string | number | null | undefined): string => {
  const statusNum = Number(status)
  return statusNum === 1 ? 'bg-green-500' : 'bg-red-500'
}

const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) return 'N/A'
  try {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  } catch {
    return 'Invalid date'
  }
}

const formatDateRange = (startDate: string | null | undefined, endDate: string | null | undefined): string => {
  if (!startDate || !endDate) return 'No schedule set'
  
  try {
    const start = new Date(startDate).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    })
    const end = new Date(endDate).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    })
    return `${start} - ${end}`
  } catch {
    return 'Invalid date range'
  }
}

const downloadFile = async () => {
  if (!props.module?.material_filepath) {
    toast.error('This module does not have a file attached.')
    return
  }

  if (!isAdmin.value) {
    toast.error('Only administrators can download module materials.')
    return
  }

  // Prevent multiple simultaneous downloads
  if (isDownloading.value) {
    toast.warning('Please wait for the current download to complete.')
    return
  }

  isDownloading.value = true
  
  // Generate unique download ID for this session
  const currentDownloadId = `download_${props.module.module_id}_${Date.now()}`
  downloadId.value = currentDownloadId
  
  try {
    const blob = await ModulesService.downloadFile(props.module.module_id)
    
    // Check if this download is still current (user hasn't cancelled)
    if (downloadId.value !== currentDownloadId) {
      return
    }
    
    // Create download link with cache-busting
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    
    // Generate filename with timestamp to avoid cache conflicts
    const originalFileName = getFileName(props.module.material_filepath)
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5)
    const fileExtension = originalFileName.split('.').pop()
    const baseName = originalFileName.replace(/\.[^/.]+$/, '')
    const fileName = `${baseName}_${timestamp}.${fileExtension}`
    
    link.download = fileName
    
    // Add cache-busting attributes
    link.setAttribute('download', fileName)
    link.style.display = 'none'
    
    // Trigger download
    document.body.appendChild(link)
    link.click()
    
    // Cleanup with slight delay to ensure download starts
    setTimeout(() => {
      if (document.body.contains(link)) {
        document.body.removeChild(link)
      }
      window.URL.revokeObjectURL(url)
    }, 100)
  } catch (error: any) {
    console.error('Download failed:', error)
    toast.error(getErrorMessage(error, 'Failed to download the file.'))
  } finally {
    isDownloading.value = false
    downloadId.value = null
  }
}

const loadFilePreview = async () => {
  if (!props.module?.material_filepath) {
    return
  }

  isLoadingPreview.value = true
  
  try {
    const response = await ModulesService.previewFile(props.module.module_id)
    if (response.success) {
      filePreview.value = response.data
      showPreview.value = true
    }
  } catch (error: any) {
    console.error('Preview failed:', error)
    toast.error(getErrorMessage(error, 'Failed to load file preview.'))
  } finally {
    isLoadingPreview.value = false
  }
}

// Window resize handler
const handleResize = () => {
  windowWidth.value = window.innerWidth
}

// Lifecycle hooks
onMounted(() => {
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})

const closeModal = () => {
  // Cancel any pending downloads
  if (downloadId.value) {
    downloadId.value = null
  }
  
  // Reset state
  isDownloading.value = false
  filePreview.value = null
  showPreview.value = false
  
  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-visible": _ctx.isVisible,
    title: _ctx.module?.name || 'Module Details',
    subtitle: "View module information and content",
    icon: _unref(BookOpen),
    size: "4xl",
    type: "default",
    "show-footer": true,
    onClose: closeModal
  }, {
    footer: _withCtx(() => [
      (_ctx.module?.material_filepath && !isAdmin.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
            _createVNode(_unref(ShieldAlert), { class: "h-4 w-4 mr-1" }),
            _cache[20] || (_cache[20] = _createTextVNode(" Download restricted to administrators ", -1))
          ]))
        : _createCommentVNode("", true),
      _createVNode(BaseButton, {
        text: "Close",
        variant: "secondary",
        onClick: closeModal
      }),
      (_ctx.module?.material_filepath && isAdmin.value)
        ? (_openBlock(), _createBlock(BaseButton, {
            key: 1,
            text: "Download Material",
            variant: "primary",
            loading: isDownloading.value,
            "loading-text": "Downloading...",
            icon: _unref(Download),
            onClick: downloadFile
          }, null, 8, ["loading", "icon"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (_ctx.module)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _cache[0] || (_cache[0] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2" }, " Module Title ", -1)),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.module.name), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[1] || (_cache[1] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2" }, " Description ", -1)),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.module.description || 'No description available'), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[2] || (_cache[2] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2" }, " Status ", -1)),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["inline-flex items-center px-3 py-1 rounded-full text-sm font-medium", getStatusClasses(_ctx.module.status)])
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["w-2 h-2 rounded-full mr-2", getStatusDotClass(_ctx.module.status)])
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(getStatusText(_ctx.module.status)), 1)
                    ], 2)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2" }, " Material ", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_unref(FileText), { class: "h-5 w-5 text-blue-500 mr-2 flex-shrink-0" }),
                      _createElementVNode("span", {
                        class: "truncate",
                        title: getFileName(_ctx.module.material_filepath)
                      }, _toDisplayString(getFileName(_ctx.module.material_filepath)), 9, _hoisted_10)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      (_ctx.module.material_filepath && isAdmin.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "inline-flex items-center px-3 py-1.5 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500/20 transition-colors",
                            onClick: downloadFile,
                            disabled: isDownloading.value,
                            title: "Download file (Admin only)"
                          }, [
                            (!isDownloading.value)
                              ? (_openBlock(), _createBlock(_unref(Download), {
                                  key: 0,
                                  class: "h-4 w-4"
                                }))
                              : (_openBlock(), _createElementBlock("div", _hoisted_13))
                          ], 8, _hoisted_12))
                        : (_ctx.module.material_filepath && !isAdmin.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createVNode(_unref(ShieldAlert), { class: "h-4 w-4" })
                            ]))
                          : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.module.material_filepath && !isAdmin.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_unref(ShieldAlert), { class: "h-4 w-4 mr-1" }),
                        _cache[3] || (_cache[3] = _createTextVNode(" Download restricted to administrators ", -1))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.module.time_setting)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _cache[5] || (_cache[5] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2" }, " Schedule ", -1)),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_unref(Calendar), { class: "h-4 w-4 text-blue-500 mr-2" }),
                          _createElementVNode("span", null, _toDisplayString(formatDateRange(_ctx.module.time_setting.start_date, _ctx.module.time_setting.end_date)), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.module.material_filepath)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3" }, " File Preview ", -1)),
                  (showPreview.value && filePreview.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", null, [
                              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "font-medium text-gray-700 dark:text-gray-300" }, "File:", -1)),
                              _createElementVNode("span", {
                                class: "ml-2 text-gray-600 dark:text-gray-400",
                                title: filePreview.value.filename.length > truncationLimit.value ? filePreview.value.filename : undefined
                              }, _toDisplayString(truncateFilename(filePreview.value.filename)), 9, _hoisted_23)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "font-medium text-gray-700 dark:text-gray-300" }, "Size:", -1)),
                              _createElementVNode("span", _hoisted_24, _toDisplayString(filePreview.value.file_size_formatted), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "font-medium text-gray-700 dark:text-gray-300" }, "Type:", -1)),
                              _createElementVNode("span", _hoisted_25, _toDisplayString(filePreview.value.file_extension.toUpperCase()), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "font-medium text-gray-700 dark:text-gray-300" }, "Created Date:", -1)),
                              _createElementVNode("span", _hoisted_26, _toDisplayString(formatDate(_ctx.module.added_at)), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          (filePreview.value.preview_type === 'pdf')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("iframe", {
                                  src: filePreview.value.file_url,
                                  class: "w-full h-96 border-none",
                                  title: "PDF Preview"
                                }, null, 8, _hoisted_29)
                              ]))
                            : (filePreview.value.preview_type === 'document')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _createVNode(_unref(FileText), { class: "h-16 w-16 text-blue-500 mx-auto mb-4" }),
                                  _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400 mb-4" }, " Document preview not supported. Please download to view. ", -1)),
                                  (isAdmin.value)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 border border-transparent rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 transition-colors",
                                        onClick: downloadFile,
                                        disabled: isDownloading.value
                                      }, [
                                        (!isDownloading.value)
                                          ? (_openBlock(), _createBlock(_unref(Download), {
                                              key: 0,
                                              class: "h-4 w-4 mr-2"
                                            }))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_32)),
                                        _cache[10] || (_cache[10] = _createTextVNode(" Download Document ", -1))
                                      ], 8, _hoisted_31))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_33, " Download restricted to administrators "))
                                ]))
                              : (filePreview.value.preview_type === 'image')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("img", {
                                      src: filePreview.value.file_url,
                                      alt: filePreview.value.filename,
                                      class: "max-w-full h-auto mx-auto rounded-lg shadow-md"
                                    }, null, 8, _hoisted_35)
                                  ]))
                                : (filePreview.value.preview_type === 'text')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                      _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400 mb-4" }, " Text file preview - Please download to view content. ", -1)),
                                      (isAdmin.value)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 border border-transparent rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 transition-colors",
                                            onClick: downloadFile,
                                            disabled: isDownloading.value
                                          }, [
                                            (!isDownloading.value)
                                              ? (_openBlock(), _createBlock(_unref(Download), {
                                                  key: 0,
                                                  class: "h-4 w-4 mr-2"
                                                }))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_38)),
                                            _cache[12] || (_cache[12] = _createTextVNode(" Download File ", -1))
                                          ], 8, _hoisted_37))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_39, " Download restricted to administrators "))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                      _createVNode(_unref(FileText), { class: "h-16 w-16 text-gray-400 mx-auto mb-4" }),
                                      _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-gray-500 dark:text-gray-400 mb-4" }, " Preview not supported for this file type ", -1)),
                                      (isAdmin.value)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 border border-transparent rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 transition-colors",
                                            onClick: downloadFile,
                                            disabled: isDownloading.value
                                          }, [
                                            (!isDownloading.value)
                                              ? (_openBlock(), _createBlock(_unref(Download), {
                                                  key: 0,
                                                  class: "h-4 w-4 mr-2"
                                                }))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_42)),
                                            _cache[14] || (_cache[14] = _createTextVNode(" Download to View ", -1))
                                          ], 8, _hoisted_41))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_43, " Download restricted to administrators "))
                                    ]))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _createVNode(_unref(FileText), { class: "h-16 w-16 text-gray-400 mx-auto mb-4" }),
                        _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-gray-500 dark:text-gray-400 mb-4" }, " Click the preview button to view file information ", -1)),
                        _createElementVNode("button", {
                          class: "inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500/20 transition-colors mr-3",
                          onClick: loadFilePreview,
                          disabled: isLoadingPreview.value
                        }, [
                          (!isLoadingPreview.value)
                            ? (_openBlock(), _createBlock(_unref(Eye), {
                                key: 0,
                                class: "h-4 w-4 mr-2"
                              }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_46)),
                          _cache[16] || (_cache[16] = _createTextVNode(" Preview File ", -1))
                        ], 8, _hoisted_45)
                      ]))
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_47, [...(_cache[19] || (_cache[19] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4" }, null, -1),
            _createElementVNode("p", { class: "text-gray-500 dark:text-gray-400" }, "Loading module details...", -1)
          ]))]))
    ]),
    _: 1
  }, 8, ["is-visible", "title", "icon"]))
}
}

})